import * as materialList from '../services/materialList';

export default {
  namespace: 'materialList',
  state: {},
  effects: {
    //素材列表
    *getMaterialList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(materialList.getMaterialList, values);
      yield put({
        type: 'save',
        payload: {
          materialData: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //删除
    *deleteMaterial({ payload: { values }, callback }, { call }) {
      const response = yield call(materialList.deleteMaterial, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
